<oph-icon [name]="formattedAlert.icon" [size]="100" [class.spin-icon]="isCoinsEarned"></oph-icon>

<h1>{{ formattedAlert.title || 'Alert' | titlecase }}</h1>

<p>{{ formattedAlert.body || 'No body' }}</p>

<oph-button color="green" [style]="{'border-radius': '12px', width: '100px'}" (buttonClick)="onClose()">OK</oph-button>
